import { constants } from "@newsela/angelou";

import {
  powerWordButtonIconHeights,
  powerWordButtonIconWidths,
  powerWordButtonBottomPaddings,
  powerWordButtonBorderBottomWidths,
  powerWordArticleBodyFontSizes,
} from "@/view/constants/styles/accessibleFontSizeMapping/accessibleFontSizeMapping.style";

const { colors } = constants;

const successGreen = colors.status.success[300];
const darkGrey = colors.ui.neutral[700];

const powerWordButtonPadding = 5;

/**
 * Calculates the position of the bolt icon.
 * @param  {number} iconHeight - Icon Height
 * @return {string} - Power word bolt icon position
 */
const getPowerWordIconPosition = (iconHeight) => {
  return `${-Math.floor(iconHeight) + powerWordButtonPadding}px`;
};

export const rootCss = {
  display: "inline-block",
  position: "relative",
  width: "fit-content",
  cursor: "pointer",

  // The first span inside of the button is the button text
  // aka the power word
  'button[aria-expanded="true"] span:first-of-type, &:hover button span:first-of-type':
    {
      borderColor: darkGrey,
    },

  // Power word bolt icon
  'button[aria-expanded="true"] svg, &:hover button svg': {
    backgroundColor: darkGrey,
    fill: successGreen,
    path: {
      stroke: successGreen,
      fill: successGreen,
    },
  },
};

export const powerWordBoltIconCss = (accessibleFontSize) => ({
  backgroundColor: successGreen,
  fill: darkGrey,
  height: `${powerWordButtonIconHeights[accessibleFontSize]}px`,
  left: 0,
  marginLeft: 0,
  padding: "1px",
  path: {
    stroke: darkGrey,
  },
  position: "absolute",
  bottom: getPowerWordIconPosition(
    powerWordButtonIconHeights[accessibleFontSize],
  ),
  width: powerWordButtonIconWidths[accessibleFontSize],
});

export const buttonCss = (accessibleFontSize) => ({
  color: darkGrey,
  fontWeight: "bold",
  lineHeight: "1.3rem",
  margin: "-5px",
  outlineOffset: 0,
  padding: "5px",
  span: {
    fontSize: powerWordArticleBodyFontSizes[accessibleFontSize],
    paddingBottom: powerWordButtonBottomPaddings[accessibleFontSize],
    marginLeft: 0,
    // The first span inside of the button is the button text
    // aka the power word
    "&:first-of-type": {
      // Position relative is needed in safari to show power word underline
      position: "relative",
      borderBottom: `${powerWordButtonBorderBottomWidths[accessibleFontSize]} solid ${successGreen}`,
    },
  },
});
